// Matches the backend's INTERRUPTED_AFTER_MS: an attempt with no outcome after
// this long cannot still be in flight, so a doctor may clear it.
const INTERRUPTED_AFTER_MS = 5 * 60_000;

export type FurstSendState =
  | "none"
  | "received"
  | "failed"
  | "inFlight"
  | "interrupted";

/**
 * "received": Fürst acknowledged it; the next run only finishes the local
 * status. "failed" / "interrupted": blocked until a doctor checks Fürst and
 * confirms it was not received. "inFlight": blocked, nothing to do yet.
 */
export function furstSendState(
  requisition: {
    furstSendAttemptId?: string | null;
    furstSendAttemptedAt?: string | null;
    furstSendUncertainAt?: string | null;
    proveId?: string | null;
    submittedAt?: string | null;
  },
  now = Date.now(),
): FurstSendState {
  if (requisition.proveId || requisition.submittedAt) return "received";
  if (!requisition.furstSendAttemptId) return "none";
  if (requisition.furstSendUncertainAt) return "failed";
  const attemptedAt = requisition.furstSendAttemptedAt
    ? Date.parse(requisition.furstSendAttemptedAt)
    : 0;
  return now - attemptedAt > INTERRUPTED_AFTER_MS ? "interrupted" : "inFlight";
}
